import {connect} from "react-redux";
import {Modal} from "bootstrap";
import AppBaseComponent from '../../../../components/AppBaseComponent';
import Loader from "../../../../components/ui/Loader/Loader";
import tapIcon from "../../../../services/TapIcon";
import Ax from "../../../../components/hoc/Ax";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import HttpAPICall from "../../../../services/HttpAPICall";
import { ORG_API_BASE_URL_2 } from "../../../../services/TapApiUrls";
import { toast } from "react-toastify";

class GeneralSetting extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initGeneralConfigForm      =   {
            enable_logistic_approval        :   'N',
            enable_deal_quotation           :   'N',
        };

        this.state                              =   {
            generalConfigloading                :   false,
            general_config_list                 :   null,
            generalConfigForm                   :   this.initGeneralConfigForm,
            editFormSubmiting                   :   false,
            configuration_form_data             :   {key : '', name: ''},
        };
        this.settingUrl         =   ORG_API_BASE_URL_2  + '/settings';
        this.settingEditUrl     =   ORG_API_BASE_URL_2  + '/setting_edit';

        this.configData     =   [
            {key : 'enable_logistic_approval', name : 'Enable Approval Process for Logistic Voucher'},
            {key : 'enable_logistic_load_detail', name : 'Configuration to Load Detail'},
        ];


    }

    componentDidMount() {
        this.getGeneralSettingListing();

        this.editApprovalStatusModal=   new Modal(document.getElementById('editApprovalStatusModal'), {keyboard: false, backdrop :false});
       
    }

    //functions for general configuration
      getGeneralSettingListing              =    ()           =>     {

        let params = {
            keys : this.configData.map(d => d.key)
        }
        this.setState({generalConfigloading : true})
        HttpAPICall.withAthorization('GET', this.settingUrl, this.props.access_token, {...params}, {}, (resp) => {
         this.setState({general_config_list  : resp.data.data})
        }).then(() => this.setState({generalConfigloading: false}));
    }

    editApprovalStatusModalInit          =    ()           =>     {
        this.editApprovalStatusModal.show();
        if(this.state.general_config_list) {
            let generalConfigForm = [];
            if (this.state.general_config_list) {
                Object.entries(this.state.general_config_list).forEach(([key, value]) => {
                  let name = key;
                  let val = value;
                  generalConfigForm[name] = val;
                });
              }
            this.setState({generalConfigForm})
        }
    }

    submitGeneralConfigurationForm        =    (e)          =>     {
        e.preventDefault();
        this.setState({editFormSubmiting : true});
        HttpAPICall.withAthorization('PUT', this.settingEditUrl, this.props.access_token, null, this.state.generalConfigForm, (response) => {
            toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
            this.editApprovalStatusModal.hide();
            this.getGeneralSettingListing();
        }).then(() => this.setState({editFormSubmiting: false}));
    }

    editGeneralConfigurationInit = (key = '', name = '') => {
        
        if(this.state.general_config_list) {
            let generalConfigForm = [];
            if (this.state.general_config_list) {
                Object.entries(this.state.general_config_list).forEach(([key, value]) => {
                  let name = key;
                  let val = value;
                  generalConfigForm[name] = val;
                });
            }
              
            this.setState({
                generalConfigForm : generalConfigForm,currentTaskKey : key, 
                configuration_form_data : {key, name}
            }, () => {
                this.editApprovalStatusModal.show();
            });
        }
    }


    generalConfigurationJsx               =    ()           =>     {
        let data = this.state.general_config_list;
          return (<table className="table table-hover table-bordered my-4 ">
              <thead className="table-secondary">
                  <tr className="text-center">
                      <th scope="col" style={{ width: "5%" }}>S.No</th>
                      <th scope="col" className="text-start">Configuration</th>
                      <th scope="col" style={{ width: "25%" }} >Value</th>
                      <th scope="col" style={{ width: "10%" }} >Action</th>
                  </tr>
              </thead>
              <tbody>
                  {
                    this.configData.map((val, i) => {
                        return (
                            <tr className="text-center">
                                <td>{++i}</td>
                                <td className="text-start">{val.name}</td>
                                <td>
                                    {
                                        data && data[val.key] === 'Y' ? 'Yes' : 'No'
                                    }
                                </td>
                                <td> <span className="dropdown">
                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a className="dropdown-item" role="button" onClick={() => this.editGeneralConfigurationInit(val.key, val.name)}>Edit</a></li>
                                    </ul>
                                </span></td>
                            </tr>
                        )
                    })
                }
              </tbody>
          </table>)
    }

    editApprovalStatusModalJsx   =    ()           =>     {
        const {configuration_form_data} =   this.state;
        return (
              <div className="modal fade" id="editApprovalStatusModal" tabIndex="-1">
                  <div className="modal-dialog modal-lg">
                      <div className="modal-content">
                          <div className="modal-header">
                              <h5 className="modal-title" id="addAssetModalLabel">Edit Approval Status</h5>
                          </div>
                          <form id="allowWorkflow" onSubmit={this.submitGeneralConfigurationForm}>
                              <div className="modal-body p-3">
                                  <div className="row align-items-center mb-2 mt-2 px-2">
                                    <div className="col-md-6"><label className="form-label">{configuration_form_data.name}</label></div>
                                    <div className="col-md-2">
                                        <label>
                                            <input
                                                type="radio"
                                                name={configuration_form_data.key}
                                                value="Y"
                                                onChange={(e) => this.formInputHandler(e, "generalConfigForm")}
                                                checked={this.state.generalConfigForm[configuration_form_data.key] == "Y"}
                                            /> Yes
                                        </label>
                                    </div>
                                    <div className="col-md-2">
                                        <label>
                                            <input
                                                type="radio"
                                                name={configuration_form_data.key}
                                                value="N"
                                                onChange={(e) => this.formInputHandler(e, "generalConfigForm")}
                                                checked={this.state.generalConfigForm[configuration_form_data.key] == "N"} /> No
                                        </label>
                                    </div>
                                </div>
                              </div>
                              <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" disabled={this.state.editFormSubmiting} data-bs-dismiss="modal">Close</button>
                                  <button type="submit" className="btn btn-primary" disabled={this.state.editFormSubmiting} >Save {this.state.editFormSubmiting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : null}</button>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          );
    }

  
    render                                  =     ()           =>     {
        return (<Ax>
            <div className="tab_content_wrapper mt-2"><span className="content_heading">General Configuration</span>
            </div>
            {this.state.generalConfigloading ? <Loader />
                : this.generalConfigurationJsx()}

            {this.editApprovalStatusModalJsx()}
        </Ax>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :        state.auth.access_token,
        permissions             :       state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps)(GeneralSetting);